// register component(s) with react habitat
import codeSplit from '@/higher-order-components/codeSplit';

export default {
	LoginMenu: codeSplit( {
		loadComponent: () =>
			import(
				/* webpackChunkName: "LoginMenu" */
				'./index'
			),
	} ),
};
